<!-- 裁判查询 -->
<template>
    <div class="page-form" >
    <Breadcrumb :title="title" />
    <div class="detail-wrap">  
        <el-row class="mg-b-20">
            <el-button type="primary" icon="el-icon-plus" @click="addDialog()">新增裁判</el-button>
        </el-row>
        <el-form :model="searchForm" ref="searchForm" :inline="true"> 
            <el-form-item label="赛事标识">
                <el-input v-model="searchForm.serialMark" placeholder="请输入赛事标识"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="searchQuery('searchForm')">查询</el-button>               
                <!-- <el-button @click="resetForm('searchForm')">重置</el-button> -->
            </el-form-item>        
        </el-form>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="index"   label="序号"   width="100" />
            <el-table-column  prop="sponsorName"  label="裁判名称"  width="180"/>
            <el-table-column  prop="sponsorId"    label="裁判账号"/>
            <el-table-column  prop="serialMark"  label="赛事标识"/>
            <el-table-column  prop="des"  label="系统内外"/>
            <el-table-column  fixed="right" label="操作"  width="120">
                <template slot-scope="scope" >
                    <el-button @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>
                </template>                   
            </el-table-column>
        </el-table>
        <pagination
            style="text-align:right"
            v-show="total > 10"
            :total="total"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.pagesize"
            @pagination="initData"
        />
    </div>
    <!-- 新增修改对话框 -->
    <el-dialog :title="titleSponsor" :visible.sync="open" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px">      
            <el-form-item label="赛事标识" prop="serialMark">
                <el-input v-model="form.serialMark"  placeholder="请输入赛事标识" :disabled="disabled"/>
            </el-form-item> 
            <el-form-item label="裁判名称" prop="sponsorName">
                <el-input v-model="form.sponsorName"  placeholder="请输入裁判名称"/>
            </el-form-item>       
            <el-form-item label="裁判账号" prop="sponsorId">
                <el-input v-model="form.sponsorId"  placeholder="请输入裁判账号"/>
            </el-form-item>            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import pagination  from '@/components/Pagination'
import Breadcrumb from '@/components/Breadcrumb'
export default {
    components:{
        pagination,
        Breadcrumb
    },
    data() {
        return {
            searchForm:{
                serialMark: '',
            },
            form: {
                index: '',
            },
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            titleSponsor: '',
            open: false,
            disabled: false,
            rules:{
                serialMark: [
                    { required: true, message: "请输入赛事标识", trigger: "blur" }
                ],
                sponsorName: [
                    { required: true, message: "请输入裁判名称", trigger: "blur" }
                ],
                sponsorId: [
                    { required: false, message: "请输入裁判账号", trigger: "blur" }
                ],
            },
        }   
    },
    created() {
        this.initData()
    },
    mounted() {

    },
    computed:{
        title(){
            return this.$route.meta.title
        }    
    },
    methods: {
        initData(){
            let params = {
                opcode:this.$code.RefereeQuery,
                i_serial_mark: this.searchForm.serialMark
            };
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.tableData = result.map(item =>{
                            return{
                                index: item['序号'],
                                sponsorId: item['裁判账号'],
                                serialMark: item['赛事标识'],
                                sponsorName: item['裁判'],
                                des: item['系统内外'],
                            }
                        })
                        this.total = res.Data.SumCount
                    }else{
                        this.tableData = []
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        addDialog(){
            this.form = {
                serialMark: '',
                sponsorName: ''
            }
            this.titleSponsor = '新增裁判'
            this.open = true
            this.disabled = false
            this.flag = 1
        },
        updateDialog(row){
            console.log("修改",row)
            this.open = true
            this.disabled = true
            this.titleSponsor = '修改裁判'
            this.flag = 2
            this.form = {...row}
        },
        submitForm(){
            let params = {
                opcode:this.$code.RefereeAddOrUpdate,
                i_serial_mark: this.form.serialMark,
                i_serial: this.form.index,
                v_referee_name: this.form.sponsorName,
                v_referee_no: this.form.sponsorId,
                v_referee_post: '',
                i_flag: this.flag
            };
            this.$api.requestAPI(params).then( res =>{
                    if(res.IsSuccess){
                        this.$message.success(res.Message);  
                        this.initData()   
                        this.open = false          
                    }else{
                        this.$message.error(res.Message);
                    }  
                }).catch( error =>{
                    console.log(error);
                })  
        },
        cancel(){
            this.open = false
            this.resetForm('form')
        },
        searchQuery() {
            this.initData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/admin/refereeQuery.vue